<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Dopo il tramonto</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent">Di Mary Calmes</p>
<p class="P_Normal__And__Left_Indent">Seguito di <i>Tempo al tempo</i></p>
<p class="P_Norm-NoIndent"><span class="C_Current__And__White_Background">Un libro della serie Tempo al tempo</span></p>
<p class="P_Normal"> </p>
<p class="P_Normal">Sono passati due anni da quando Stefan Joss si è trasferito nel sud degli Stati Uniti per amore del rancher Rand Holloway. Stef ha cercato – con esitazione – di adeguarsi alla sua nuova vita, ma il vero amore non fila mai liscio come dovrebbe. Rand vuole che lui rimanga a casa al ranch, Stef vuole avere una rete di sicurezza nel caso Rand decida di sbarazzarsi di lui. Finalmente, dopo aver capito di essere stato ingiusto a dubitare di lui, Stef decide di impegnarsi sul serio con Rand e l’uomo è al settimo cielo.</p>
<p class="P_Normal">Quando Stef ha l’opportunità di provare il suo amore, non si tira indietro, mettendo a repentaglio la sua stessa vita. E Rand ha la possibilità di dimostrare che – a volte – la vita può sorprenderti quando meno te lo aspetti.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?00e43623